var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-popups v-popups--dark" }, [
    _c("div", { staticClass: "v-popups__main" }, [
      _c("div", { staticClass: "v-tooltip__main" }, [
        _c("div", { staticClass: "v-tooltip__content" }, [
          _vm._v(_vm._s(_vm.value)),
        ]),
      ]),
    ]),
    _c("i", {
      staticClass: "v-popups__arrow v-popups__arrow v-popups__arrow--top",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }